import styled, { css } from 'styled-components';
import { MenuItem } from '@mui/material';
import { Typography } from '../../atoms';
import { Colors } from '../../../theme';

export const StyledLabel = styled(Typography)<{ isRequired?: boolean; disabled?: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme: { color }, disabled }) => disabled && color.textGray};
  ${({ isRequired }) =>
    isRequired &&
    css`
      :after {
        content: ' *';
        color: ${({ theme: { color } }) => color.red};
      }
    `}
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: ${({ theme }) => theme.spacing(4)};
  &.Mui-selected {
    background-color: ${({ theme: { color, palette } }) =>
      palette.mode === 'dark' ? color.secondaryTextGray : color.backgroundSelected};
  }
`;

export const StyledHelperText = styled(Typography)<{ $helperTextColor: Colors }>`
  color: ${({ theme, $helperTextColor }) => theme.color[$helperTextColor]};
`;
